/* eslint-disable no-unused-vars */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-void */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useFormik } from 'formik';
import { useLoadScript } from '@react-google-maps/api';
import _ from 'lodash';
import {
  CheckboxInput,
  Preloader,
} from '@cochlear-design-system/foundation';

import {
  checkIsFutureDate,
  checkIsPastDate,
  checkIsValidDateTime,
  // checkIsValidPhoneNumber,
  checkIsValidPostCode,
  checkMask,
  checkMinLenght,
  checkRequired,
  checkMaxLength,
} from '../utils/adaptiveForm/Validator';
import { LocationSearchInputAddressInput } from '../LocationSearchInput/LocationSearchInputAddressInput.jsx';
import { AddressFieldsView } from '../AddressFieldsView/AddressFieldView.jsx';
import { splitStreet } from '../utils/address';

export const AddressInputWithFieldsView = forwardRef((props, ref) => {
  const {
    id,
    error,
    errorMsg,
    disabled,
    name,
    labels,
    config,
    value,
    onChange,
    hint,
    optional,
    promptText,
    promptMobile,
    loading,
    addressNotFoundText,
    addressNotFoundButton,
    lookupErrorLabel,
    label,
    currentCountry,
  } = props;

  const {
    fields,
    postcodeMask: configPostcodeMask,
    focusName,
    onSaveHandle,
    addressAPIState,
    googleMapsApiKey,
    apiEndpoint,
    countryStates: configCountryStates,
    language,
    sourceAddressConfigFromApi,
    disableLiveValidation,
    disableGoogleMapsApi,
  } = config;

  const checkStateName =
    addressAPIState?.addressAPIStateName === 'short_name';

  const addressId = value?.id || '';
  const isPO = value?.isPO || '';
  const originalAddressText = value?.address?.addressText || '';
  const originalStreet = value?.address?.street
    ? [value?.address?.street]
    : [];
  const originalCity = value?.address?.city || '';
  const originalState = value?.address?.state || '';
  const originalPostcode = value?.address?.postalCode || '';

  const [libraries] = useState(['places', 'geometry']);
  const result = useLoadScript({
    googleMapsApiKey,
    libraries,
  });

  const isLoaded = disableGoogleMapsApi ? false : result.isLoaded;
  const loadError = disableGoogleMapsApi ? true : result.loadError;

  const [addressText, setAddressText] = useState(
    originalAddressText || '',
  );
  const [street, setStreet] = useState(originalStreet || []);
  const [city, setCity] = useState(originalCity || '');
  const [state, setState] = useState(originalState || '');
  const [postcode, setPostcode] = useState(originalPostcode || '');
  const [isPo, setIsPo] = useState(isPO || '');

  const [countryStates, setCountryStates] = useState(
    configCountryStates,
  );
  const [postcodeMask, setPostcodeMask] = useState(
    configPostcodeMask,
  );

  const [country, setCountry] = useState(
    currentCountry ||
      config?.countryIso2Code ||
      value?.country ||
      config?.country,
  );

  useEffect(() => {
    if (!config?.country) return;
    setCountry(config.country);
  }, [config?.country]);

  useEffect(() => {
    if (!sourceAddressConfigFromApi) return;

    fetch(
      `${apiEndpoint}/utils/regions?lng=${
        language ?? 'en'
      }&country=${country}`,
    )
      .then((res) => res.json())
      .then((response) => {
        const newPostcodeMask =
          response.data?.country?.postalCodeFormat;
        const newCountryStates = response.data?.regions?.map(
          (region) => ({
            label: region.name,
            value: region.abbr,
          }),
        );

        if (newPostcodeMask) setPostcodeMask(newPostcodeMask);
        if (newCountryStates) setCountryStates(newCountryStates);
      })
      .catch((err) => {
        console.error('Error fetching regions:', err);
      });
  }, [country, sourceAddressConfigFromApi, apiEndpoint, language]);

  useEffect(() => {
    if (currentCountry) {
      setCountry(currentCountry);
    }
  }, [currentCountry]);

  // true unless the api has a load error
  const [readOnly, setReadOnly] = useState(!loadError);

  // Count IsPo clicks
  const [countIsPo, setCountIsPo] = useState(0);

  // Determine whether the street is modified
  const [streetModi, setStreetModi] = useState(0);

  // Local state for validation errors (for immediate display)
  const [localErrors, setLocalErrors] = useState({});

  const setCountIsPoF = () => {
    return setCountIsPo(countIsPo + 1);
  };

  const enableForm = () => {
    setCountIsPoF();
    setReadOnly(false);
    setIsPo(true);
  };

  useEffect(() => {
    // hack: we need this to persist the "PO Box" checked value
    if (isPo) {
      setReadOnly(false);
      setCountIsPo(1);
    }
  }, [isPo]);

  useEffect(() => {
    if (loadError) setIsPo(true);
  }, [loadError]);

  const postcodeField = fields.filter((x) => x.id === 'postcode')[0];
  const postcodeValidator = postcodeField
    ? postcodeField.validators.filter((y) => y.key === 'postcode')[0]
    : null;

  if (postcodeValidator && postcodeMask)
    postcodeValidator.mask = postcodeMask;

  const CheckboxHandleChange = (t) => {
    setCountIsPo(countIsPo + 1);
    setReadOnly(!t.target.checked);
    setIsPo(t.target.checked);
  };

  // if user via google to fill address will validate the from
  const setValidation = () => {
    setCountIsPo(countIsPo + 1);
    setStreetModi(streetModi + 1);
  };

  const onSubmit = (values, { setSubmitting }) => {
    /* #5 */
    setValidation();

    if (_.isArray(values.street)) {
      values.street = _.join(values.street, ', ');
    }

    values.street = values.street?.trim().split(/[(\r\n)\r\n]+/);
    const finalValues = {
      address: values,
      isPO: isPo,
    };
    if (onSaveHandle) {
      onSaveHandle(finalValues, { setSubmitting });
    }
  };

  const onValidateForm = (values, fields, labels) => {
    const errors = {};

    fields.forEach((element) => {
      const { validators, apifield } = element;

      // address tag validation
      if (
        apifield === 'isBilling' ||
        apifield === 'isMailing' ||
        apifield === 'isShipping'
      ) {
        if (
          !values.isBilling &&
          !values.isMailing &&
          !values.isShipping
        ) {
          errors.isBilling = 'Required';
          errors.isMailing = 'Required';
          errors.isShipping = 'Required';
        }
      }

      if (validators.length === 0) return false;

      if (!errors[apifield])
        checkRequired(element, values, errors, labels);

      if (!errors[apifield])
        checkMinLenght(element, values, errors, labels);

      if (!errors[apifield])
        checkMaxLength(element, values, errors, labels);

      if (!errors[apifield])
        checkMask(element, values, errors, labels);

      if (!errors[apifield])
        checkIsValidDateTime(element, values, errors, labels);

      if (!errors[apifield])
        checkIsFutureDate(element, values, errors, labels);

      if (!errors[apifield])
        checkIsPastDate(element, values, errors, labels);

      if (!errors[apifield])
        checkIsValidPostCode(element, values, errors, labels);

      // if (!errors[apifield])
      //  checkIsValidPhoneNumber(element, values, errors, labels);

      return false;
    });

    return errors;
  };

  const formik = useFormik({
    key: readOnly,
    initialValues: readOnly
      ? {
          street: splitStreet(originalStreet),
          city: originalCity,
          state: originalState,
          postcode: originalPostcode,
          country,
          isPO,
        }
      : {
          street: splitStreet(street),
          city,
          state,
          postcode,
          country,
          isPO: isPo,
        },
    validate: (values) => {
      if (disableLiveValidation) {
        return false;
      }

      if (
        countIsPo === 1 &&
        streetModi === 0 &&
        isPo &&
        !isPO &&
        !error &&
        !addressId &&
        !formik.dirty
      ) {
        return false;
      }

      return onValidateForm(values, fields, labels);
    },
    onSubmit,
    initialTouched: {
      street: true,
      city: true,
      state: true,
      postcode: true,
      country: true,
      isPO: false,
    },
    // isInitialValid: true,
    initialErrors: {},
  });

  useEffect(() => {
    if (streetModi !== 0) {
      void formik.setFieldTouched('isPO');
      void formik.setFieldValue('isPO', isPo);
    }
  }, [streetModi, isPo]);

  useEffect(() => {
    if (value?.id && isPo) {
      setReadOnly(false);
    }
    if (value?.id) {
      void formik.validateForm(formik.values);
    }
  }, [isPo, value]);

  // identify google address has been update in formik
  const [isUpdateAddress, setIsUpdateAddress] = useState(0);

  const updateAddress = (obj, formik, updateFields = true) => {
    if (_.isArray(obj.street)) {
      obj.street = _.join(obj.street, ', ');
    }

    setAddressText(obj.addressText);
    setStreet(obj.street?.trim().split(/[(\r\n)\r\n]+/));
    setCity(obj.city);
    setState(obj.state);
    setPostcode(obj.postcode);

    if (updateFields) {
      Object.entries(obj).forEach(([key, value]) => {
        formik.setFieldTouched(key);
        formik.setFieldValue(key, value);
      });

      async function setFormikValues() {
        await formik.setValues(obj);
        if (addressId) {
          setIsUpdateAddress(
            (prevIsUpdateAddress) => prevIsUpdateAddress + 1,
          );
        } else {
          setIsUpdateAddress(
            (prevIsUpdateAddress) => prevIsUpdateAddress + 2,
          );
        }
      }
      setFormikValues().catch((error) => {
        console.error('Error setting formik values:', error);
      });
    } else {
      setIsUpdateAddress(0);
    }
  };

  // if isUpdateAddress is true then trigger onChange
  useEffect(() => {
    if (isUpdateAddress > 1) {
      onChange(formik);
    }
  }, [isUpdateAddress]);

  // Removed unused onSaveError function

  const [focus, setFocus] = useState(false);

  const doValidateForm = (
    displayErrors = true,
    valuesToValidate = null,
  ) => {
    const errors = onValidateForm(
      valuesToValidate || formik.values,
      fields,
      labels,
    );

    if (displayErrors) {
      setLocalErrors(errors);
      formik.setErrors(errors);
    }

    return errors;
  };

  // Run initial validation when form loads with disableLiveValidation
  useEffect(() => {
    if (disableLiveValidation && !readOnly && formik.values) {
      const errors = onValidateForm(formik.values, fields, labels);
      setLocalErrors(errors);
      formik.setErrors(errors);
    }
  }, [disableLiveValidation, readOnly]);

  useImperativeHandle(ref, () => ({
    formik,
    setFocus,
    doValidateForm,
  }));

  if (
    (!isLoaded && loadError === undefined) ||
    config?.fields === undefined
  ) {
    return (
      <Preloader
        style={{ marginTop: '2rem', marginBottom: '1rem' }}
        lines={['title', 'label', 'line', 'line', 'line']}
      />
    );
  }

  return (
    <>
      <div
        style={{ marginTop: '2rem' }}
        className="ccl__view-edit-mode--address-view ccl__view-edit-mode--addressInput-view"
      >
        <fieldset disabled={formik.isSubmitting}>
          {!loadError && (
            <>
              <LocationSearchInputAddressInput
                error={
                  (Object.getOwnPropertyNames(formik.errors)?.length >
                    0 &&
                    readOnly) ||
                  error
                    ? labels[lookupErrorLabel] || errorMsg
                    : undefined
                }
                setFocus={
                  (focusName !== undefined &&
                    Object.getOwnPropertyNames(formik.errors)
                      ?.length > 0) ||
                  setFocus
                }
                id={id}
                name={name}
                country={country}
                searchCharLength={config.searchCharLength}
                address={{
                  addressText,
                  street: splitStreet(street),
                  city,
                  state,
                  postcode,
                  country,
                }}
                optionalText={labels[optional]}
                hint={labels[hint]}
                label={labels[label]}
                promptText={labels[promptText]}
                promptMobile={labels[promptMobile]}
                loadingText={labels[loading]}
                addressNotFound={{
                  text: labels[addressNotFoundText],
                  button: labels[addressNotFoundButton],
                }}
                updateAddress={updateAddress}
                enableForm={enableForm}
                disabled={!readOnly || disabled}
                isFilled={value?.id && !isPo}
                isPo={isPo}
                countryStates={countryStates}
                data-nw-addresslookup
                formik={formik}
                addressAPIState={addressAPIState}
              />

              <CheckboxInput
                label={
                  labels[
                    fields.filter((x) => x.id === 'isPO')[0].label
                  ]
                }
                name={fields.filter((x) => x.id === 'isPO')[0].name}
                className="ccl__form-input__isPo"
                id={fields.filter((x) => x.id === 'isPO')[0].id}
                checked={isPo}
                onChange={(e) => {
                  CheckboxHandleChange(e);
                }}
                disabled={disabled}
                value={isPo}
              />
            </>
          )}

          <div
            className={
              !readOnly
                ? 'ccl__view-edit-mode__showPO'
                : 'ccl__view-edit-mode__hiddenPO'
            }
          >
            <AddressFieldsView
              config={config}
              labels={labels}
              readOnly={!!(readOnly || disabled)}
              onChange={(e, v) => {
                const updatedValues = { ...formik.values };
                let fieldName = '';

                if (e === 'state') {
                  setStreetModi(streetModi + 1);
                  const cState = countryStates?.filter((s) => {
                    return s.label === v || s.value === v;
                  });
                  const stateValue = checkStateName
                    ? cState[0]?.value
                    : cState[0]?.label;
                  formik.handleChange({
                    target: {
                      name: e,
                      value: stateValue,
                    },
                  });
                  updatedValues.state = stateValue;
                  fieldName = 'state';
                  setIsUpdateAddress(
                    (prevIsUpdateAddress) => prevIsUpdateAddress + 1,
                  );
                } else {
                  formik.handleChange(e);
                  // Extract field name and value from event
                  fieldName = e.target?.name || e;
                  const fieldValue = e.target?.value;
                  if (fieldName && fieldValue !== undefined) {
                    updatedValues[fieldName] = fieldValue;
                  }
                }
                // Run validation on change with updated values
                if (disableLiveValidation && fieldName) {
                  const errors = onValidateForm(
                    updatedValues,
                    fields,
                    labels,
                  );
                  // Use local state for immediate error display
                  setLocalErrors(errors);
                  formik.setErrors(errors);
                }
              }}
              onBlur={(e) => {
                setStreetModi(streetModi + 1);
                formik.handleBlur(e);
                // Run validation on blur when live validation is disabled
                // Use setTimeout to ensure formik values are updated before validation
                if (disableLiveValidation) {
                  setTimeout(() => {
                    const errors = doValidateForm(true);
                    setLocalErrors(errors);
                    onChange(formik);
                  }, 0);
                } else {
                  onChange(formik);
                }
              }}
              values={formik.values}
              errors={
                (!readOnly && { ...formik.errors, ...localErrors }) ||
                {}
              }
              touched={formik.touched}
              setFieldValue={formik.setFieldValue}
              setFieldTouched={formik.setFieldTouched}
              countryStates={countryStates}
            />
          </div>
        </fieldset>
      </div>
    </>
  );
});
